import { render } from "./Erequisition.vue?vue&type=template&id=4044d3c1"
import script from "./Erequisition.vue?vue&type=script&lang=js"
export * from "./Erequisition.vue?vue&type=script&lang=js"

import "./Erequisition.vue?vue&type=style&index=0&id=4044d3c1&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/Erequisition.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4044d3c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4044d3c1', __exports__)) {
    console.log('reload')
    api.reload('4044d3c1', __exports__)
  }
  
  module.hot.accept("./Erequisition.vue?vue&type=template&id=4044d3c1", () => {
    console.log('re-render')
    api.rerender('4044d3c1', render)
  })

}


export default __exports__